import {
  ArrowRight,
  Headset,
  Rocket,
  ShieldCheck,
  Zap,
} from "lucide-react";
import SiteFooter from "./SiteFooter";

const APP_URL = "https://connect.cullath.com/desktop/Cullath.exe";

export default function HeroClosingSection() {
  return (
    <section className="hcs-ending-section" aria-label="Start with Cullath and footer navigation">
      <section className="hcs-ready-section" aria-labelledby="hcs-ready-title">
        <div className="hcs-ready-orbit hcs-ready-orbit--one" aria-hidden="true" />
        <div className="hcs-ready-orbit hcs-ready-orbit--two" aria-hidden="true" />
        <div className="hcs-ready-orbit hcs-ready-orbit--three" aria-hidden="true" />
        <span className="hcs-orbit-node hcs-orbit-node--one" aria-hidden="true" />
        <span className="hcs-orbit-node hcs-orbit-node--two" aria-hidden="true" />
        <span className="hcs-orbit-node hcs-orbit-node--three" aria-hidden="true" />
        <span className="hcs-orbit-node hcs-orbit-node--four" aria-hidden="true" />

        <div className="hcs-ready-container">
          <div className="hcs-ready-copy">
            <span className="hcs-ready-icon" aria-hidden="true"><Rocket size={25} /></span>
            <div>
              <h2 id="hcs-ready-title">Ready to Work <span>Smarter?</span></h2>
              <p>Experience a better way to communicate, collaborate, manage work, and support your teams—all from one connected platform.</p>
            </div>
          </div>

          <div className="hcs-ready-actions">
            <a className="hcs-demo-button" href="https://connect.cullath.com">Sign In <ArrowRight size={17} /></a>
            <a className="hcs-start-button" href={APP_URL}>DownLoad<ArrowRight size={17} /></a>
          </div>
        </div>

        <div className="hcs-ready-trust" aria-label="Getting started benefits">
          <span><ShieldCheck size={17} /> No credit card required</span>
          <span><Zap size={17} /> Quick setup</span>
          <span><Headset size={17} /> Dedicated support</span>
        </div>
      </section>

      <SiteFooter />
    </section>
  );
}
